import React, { Component } from 'react';
import { string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';
// import { propTypes } from '../../../util/types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import * as validators from '../../util/validators';
import arrayMutators from 'final-form-arrays';
import referralImage from '../../assets/image/refeeralImage.jpeg';
import logo from '../../assets/image/favIcon.png';

import {
  Form,
  Button,
  FieldTextInput,
  H3,
  H1,
  FieldCheckboxGroup,
  H4,
  H5,
  IconCard,
} from '../../components';

import css from './ReferralCodeForm.module.css';
import { Icon } from '../../components/IconAdd/IconAdd.example';
import Slider from 'react-slick';
class ReferralCodeFormComponent extends Component {
  constructor(props) {
    super(props);
    this.uploadDelayTimeoutId = null;
    this.state = {
      uploadDelay: false,
      loading: true,
    };
    this.submittedValues = {};
  }

  componentDidUpdate(prevProps) {
    // Upload delay is additional time window where Avatar is added to the DOM,
    // but not yet visible (time to load image URL from srcset)
    if (prevProps.uploadInProgress && !this.props.uploadInProgress) {
      this.setState({ uploadDelay: true });
      this.uploadDelayTimeoutId = window.setTimeout(() => {
        this.setState({ uploadDelay: false });
      }, UPLOAD_CHANGE_DELAY);
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.uploadDelayTimeoutId);
  }
  componentDidMount() {
    // Here you can fetch referralContent or perform any other initialization

    // For demonstration, let's assume referralContent is fetched asynchronously
    setTimeout(() => {
      // Once content is fetched, set loading state to false
      this.setState({ loading: false });
    }, 2000); // Simulating a delay of 2 seconds (replace with actual fetching logic)
  }
  render() {
    return (
      <FinalForm
        keepDirtyOnReinitialize={true}
        mutators={{ ...arrayMutators }}
        {...this.props}
        render={fieldRenderProps => {
          const {
            className,
            handleSubmit,
            intl,
            invalid,
            pristine,
            rootClassName,
            form,
            values,
            updateInProgress,
            uploadInProgress,
            formId,
            referralContent,
          } = fieldRenderProps;

          const classes = classNames(rootClassName || css.root, className);
          const submitInProgress = updateInProgress;
          const submittedOnce = Object.keys(this.submittedValues).length > 0;
          const pristineSinceLastSubmit = submittedOnce && isEqual(values, this.submittedValues);
          const submitDisabled =
            invalid || pristine || pristineSinceLastSubmit || uploadInProgress || submitInProgress;
          const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
          };
          const { loading } = this.state;

          return (
            <div>
              <div className={css.referralWrapper}>
                <div className={css.refrelLeft}>
                  <Form
                    className={classes}
                    onSubmit={e => {
                      this.submittedValues = values;
                      handleSubmit(e);
                      form.reset();
                    }}
                  >
                    <div className={css.sectionContainer}>
                      <H4 as="h2" className={css.sectionTitle}>
                        <FormattedMessage id="ReferralCodeForm.referralHeading" />
                      </H4>

                      <H5 as="h2" className={css.sectionInfo}>
                        If you know any other vendor who could benefit from MyFindor, refer them.
                        Once they purchase their credit pack, you both will get free credits.
                      </H5>

                      <div className={css.contactInnerWrapper}>
                        <p>
                          Kindly enter the email address of your friend to whom you want to refer.
                        </p>
                        <div className={css.nameContainer}>
                          <FieldTextInput
                            className={css.input}
                            type="email"
                            id={formId ? `${formId}.email` : 'email'}
                            name="email"
                            autoComplete="given-email"
                            placeholder={intl.formatMessage({
                              id: 'ReferralCodeForm.emailPlaceholder',
                            })}
                            validate={validators.required(
                              intl.formatMessage({
                                id: 'ReferralCodeForm.emailRequired',
                              })
                            )}
                          />
                          <div className={css.formsubmitWrapper}>
                            <Button
                              className={css.submitButton}
                              type="submit"
                              disabled={submitDisabled}
                              inProgress={submitInProgress}
                              ready={pristineSinceLastSubmit}
                            >
                              <FormattedMessage id="ReferralCodeForm.submit" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
                <div className={css.rightImage}>
                  {this.state.loading ? (
                    <div className={css.loaderWrapper}>
                      <span className={css.loader}></span>
                    </div>
                  ) : (
                    <>
                      {referralContent &&
                        referralContent !== 0 &&
                        referralContent?.map((items, index) => {
                          const url = items?.attributes?.url;
                          if (url) {
                            return (
                              <div key={index} className={css.refrelImage}>
                                <img src={url} />
                              </div>
                            );
                          }
                        })}
                    </>
                  )}
                </div>
              </div>
              <div className={css.bottomSection}>
                <div className={css.shareGrid}>
                  <div className={css.people}>
                    <IconCard brand="people" />
                    <div className={css.text}>Refer a Friend by sending an invite.</div>
                  </div>
                  <div className={css.logo}>
                    <img src={logo} />
                    <div className={css.text}>Friends sign up and purchase credits.</div>
                  </div>
                  <div className={css.people}>
                    <IconCard brand="credit" />
                    <div className={css.text}>We send you both free credits.</div>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      />
    );
  }
}

ReferralCodeFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  uploadImageError: null,
  updateProfileError: null,
  updateProfileReady: false,
};

ReferralCodeFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  // from injectIntl
  intl: intlShape.isRequired,
};

const ReferralCodeForm = compose(injectIntl)(ReferralCodeFormComponent);

ReferralCodeForm.displayName = 'ContactUsForm';

export default ReferralCodeForm;
